import isEmpty from 'lodash/isEmpty'
import { FileUploader } from '@ztechapps/webui.input'
import { useAssetPageContext } from './Context'
import { useToast } from '@ztechapps/common.hook'
import type { File } from '@ztechapps/common.contract'
import { AssetTypeEnum } from '@ztechapps/common.contract'

const toAssetType = (type: string): AssetTypeEnum => {
  if (!type) return AssetTypeEnum.raw

  if (type.startsWith('image/')) return AssetTypeEnum.image
  if (type.startsWith('video/')) return AssetTypeEnum.video

  // Common document MIME types
  const documentTypes = new Set([
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/csv',
    'application/csv',
    'text/plain',
  ])

  if (documentTypes.has(type)) return AssetTypeEnum.document

  return AssetTypeEnum.raw
}

interface UploadViaUppyProps {
  uploadText?: string
}

export const UploadViaUppy = ({ uploadText }: UploadViaUppyProps) => {
  const { canEdit, onSetFileMeta, onCreateAsset } = useAssetPageContext()
  const { showSuccess } = useToast()

  const onUploadComplete = async (files: File[]) => {
    if (isEmpty(files)) return

    // Use child resolver mutation pattern for each file
    // This triggers AssetChildRepository.preSave for URL sanitization
    for (const file of files) {
      await onCreateAsset({
        title: file.name,
        url: file.uri,
        type: toAssetType(file.mimetype),
      })
    }

    showSuccess({ message: 'Successfully uploaded assets.' })
  }

  return (
    <FileUploader
      onUploadComplete={onUploadComplete}
      disabled={!canEdit}
      onSetFileMeta={onSetFileMeta}
      uploadText={uploadText}
    />
  )
}
